if (!customElements.get("quick-add-variant")) {
  customElements.define(
    "quick-add-variant",
    class QuickAddVariant extends HTMLElement {
      connectedCallback() {
        this.addButton = this.querySelector("button");
        this.productHandle = this.getAttribute("data-product-handle");
        
        if (this.addButton) {
          this.addButton.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.addFirstAvailableVariant();
          });
        }
      }

      async addFirstAvailableVariant() {
        try {
          // Show loading state
          const originalText = this.addButton.textContent;
          this.addButton.textContent = "Adding...";
          this.addButton.disabled = true;

          // Fetch product data
          const response = await fetch(`/products/${this.productHandle}.js`);
          const product = await response.json();

          // Find the first available variant
          const firstAvailableVariant = product.variants.find(variant => variant.available);
          
          if (!firstAvailableVariant) {
            throw new Error("No available variants found");
          }

          // Set custom data for elevar tracking (see snippets/elevar-customisations.liquid)
          window.__elevarCustomData = {
            upsell_product: this.addButton.dataset.upsellProduct,
            upsell_block: this.addButton.dataset.upsellBlock,
            upsell_category: this.addButton.dataset.upsellCategory,
          };

          // Add to cart
          const formData = {
            'items': [{
              'id': firstAvailableVariant.id,
              'quantity': 1
            }]
          };

          const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });

          const cartData = await cartResponse.json();

          if (cartResponse.ok) {
            // Success - show success state briefly
            this.addButton.textContent = "Added!";
            this.addButton.classList.add("added");
            
            // Trigger cart update events for other components
            this.dispatchCartUpdateEvents(cartData, firstAvailableVariant.id);
            
            // Reset button after 2 seconds
            setTimeout(() => {
              this.addButton.textContent = originalText;
              this.addButton.disabled = false;
              this.addButton.classList.remove("added");
            }, 2000);
          } else {
            throw new Error(cartData.description || "Failed to add to cart");
          }
        } catch (error) {
          console.error("Error adding product to cart:", error);
          
          // Show error state
          this.addButton.textContent = "Error";
          this.addButton.classList.add("error");
          
          // Reset button after 3 seconds
          setTimeout(() => {
            this.addButton.textContent = "Add to Cart";
            this.addButton.disabled = false;
            this.addButton.classList.remove("error");
          }, 3000);
        }
      }

      dispatchCartUpdateEvents(cartData, productVariantId) {
        // Dispatch the cart-drawer:refresh event
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
          detail: { 'response': cartData },
          bubbles: true,
          composed: true
        }));

        // Dispatch the PUB_SUB_EVENTS.cartUpdate event
        if (typeof window.publish !== 'undefined' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-add-variant",
            productVariantId: productVariantId,
            cartData: cartData,
          });
        } else if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-add-variant",
            productVariantId: productVariantId,
            cartData: cartData,
          });
        }

        // Also dispatch the cart:updated event for other components
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cartData: cartData },
          bubbles: true,
          composed: true
        }));
      }
    }
  );
}
